import {
  WATERMARK_BACKGROUND,
  WATERMARK_TEXT,
  WATERMARK_TEXT_COLOR,
  watermarkLayout,
  watermarkMetrics,
} from '@better-lights/core';
import { LEGEND_FONT } from './legend.ts';

type Ctx2D = OffscreenCanvasRenderingContext2D | CanvasRenderingContext2D;

const rgba = (hex: string, a: number) => {
  const n = Number.parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
};

/**
 * Free-plan watermark (docs/spec/08 §1): a pill in the bottom-right of the FINAL image, geometry
 * from core (`watermarkLayout`), text in Inter SemiBold measured by advance width.
 */
export function drawWatermark(ctx: Ctx2D, width: number, height: number): void {
  const m = watermarkMetrics(width, height);
  ctx.save();
  ctx.font = `600 ${m.fontSize}px ${LEGEND_FONT}, sans-serif`;
  const layout = watermarkLayout(width, height, ctx.measureText(WATERMARK_TEXT).width);
  ctx.fillStyle = rgba(WATERMARK_BACKGROUND.color, WATERMARK_BACKGROUND.alpha);
  ctx.beginPath();
  ctx.roundRect(layout.rect.x, layout.rect.y, layout.rect.width, layout.rect.height, layout.radius);
  ctx.fill();
  ctx.fillStyle = rgba(WATERMARK_TEXT_COLOR.color, WATERMARK_TEXT_COLOR.alpha);
  ctx.textBaseline = 'middle';
  ctx.textAlign = 'left';
  ctx.fillText(WATERMARK_TEXT, layout.textX, layout.centerY);
  ctx.restore();
}
